import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    background: C.cardBg,
    borderRadius: 8,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    width: '100%',
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },
  iconBox: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: 4,
    backgroundColor: C.iconBoxBg,
    '& svg': { fontSize: 12, color: C.strongText },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.strongText,
    margin: 0,
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexShrink: 0,
  },
  chevron: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '& svg': { fontSize: 12, color: C.strongText },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}))
